import Swiper from 'swiper';

const singleProductGallery = new Swiper('.singleProductGallery', {
  speed: 400,
  slidesPerView: 3,
  spaceBetween: 8,
  navigation: {
    nextEl: '.singleProductGallery__next',
    prevEl: '.singleProductGallery__prev',
  },
  breakpoints: {
    // // when window width is <= 320px
    // 320: {
    //   slidesPerView: 1,
    //   spaceBetween: 10,
    // },
    // // when window width is <= 480px
    // 480: {
    //   slidesPerView: 2,
    //   spaceBetween: 20,
    // },
    // // when window width is <= 640px
    480: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
  },
});

const expandImageOnClick = (images) => {
  Array.from(images).forEach((image) => {
    image.children[0].addEventListener('click', (e) => {
      const body = document.getElementsByTagName('body')[0]; // Get body element
      const imageSrc = e.target.getAttribute('src'); // Get Src of Clicked Image
      const fullImage = document.createElement('IMG'); // Create Img
      const closeBtn = document.createElement('SPAN'); // Create Span (X button)
      const imageWrapper = document.createElement('DIV'); // Create Div
      imageWrapper.classList.add('imageWrapper'); // Assign the class to that Div
      fullImage.src = imageSrc; // Add Src of clicked image to a NEW Created image
      imageWrapper.appendChild(fullImage); // Append image to the Wrapper
      imageWrapper.appendChild(closeBtn); // Append Close Btn to the Wrapper
      body.appendChild(imageWrapper); // Append Wrapper to body

      document.querySelector('.imageWrapper span').addEventListener('click', () => {
        document.querySelector('.imageWrapper').remove();
      });
    });
  });
};

const expandImage = () => {
  const galleryHolder = document.querySelector('.singleProductGallery > .swiper-wrapper');
  const images = galleryHolder.children;

  if (galleryHolder) {
    expandImageOnClick(images);
  }
};

// expandImage();

const relatedProducts = new Swiper('.relatedProductSlider', {
  speed: 400,
  freeMode: true,
  slidesPerView: 'auto',
  spaceBetween: 8,
  breakpoints: {
    // // when window width is <= 320px
    // 320: {
    //   slidesPerView: 1,
    //   spaceBetween: 10,
    // },
    // // when window width is <= 480px
    // 480: {
    //   slidesPerView: 2,
    //   spaceBetween: 20,
    // },
    // // when window width is <= 640px
    480: {
      spaceBetween: 14,
    },
  },
});
